export default __webpack_public_path__ + "static/byron_workbooks-d19fd15e08b60d8e1f89d05d07e0fcf8.jpg";